import type { Vector3 } from '@anov/3d-core'

export interface IPanel {
  /** 打开面板 */
  open: () => void
  /** 关闭面板 */
  close: () => void
  /** 更新面板 */
  update: (option: Option) => void
  /** 销毁面板 */
  destroy: () => void
  /** 播放 */
  play: () => void
  /** 暂停 */
  pause: () => void
  /** 设置音量 */
  setVolume: (volume: number) => void
  /** 跳转 */
  seek: (time: number) => void
  /** 切换静音 */
  toggleMute: () => void
  /** 获取视频时长 */
  get duration(): number
  /** 获取当前播放时间 */
  get currentTime(): number
  /** 获取是否播放中 */
  get isPlaying(): boolean
}

// 面板配置项
export type Option = Partial<{
  title: TitleOption // 标题
  position: Vector3 // 位置
  width: number | string // 宽度
  height: number | string // 高度
  bgColor: string // 背景颜色
  bgUrl: string // 背景图片
  borderRadius: number // 圆角
  padding: string // 内边距
  closeable: boolean // 是否显示关闭按钮
  className: string // 自定义类名
  customStyle: object // 自定义样式
  autoplay: boolean // 是否自动播放
  loop: boolean // 是否循环播放
  controls: boolean // 是否显示控制按钮
  muted: boolean // 是否静音
  src: string // 视频地址
  volume: number // 音量
  poster: string // 视频封面
  videoWidth: number // 视频宽度
  videoHeight: number // 视频高度
  onClose: () => void // 关闭回调
}>

// 标题
export type TitleOption = Partial<{
  value: string
  fontSize: string
  color: string
  fontFamily: string
  fontWeight: number
  lineHeight: number | string
  textAlign: string
  padding: string
  margin: string
  icon: string
}>